import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message } from "antd";
// import AmCharts from "@amcharts/amcharts3-react";
import { LoadingOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const BasicBarGraphHor = (props) => {
  if (props.divId === "mtdData") {
    console.log(props.data);
  }
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);

  useEffect(() => {
    let x = am4core.create(
      props.divId ? props.divId : "DivID",
      am4charts.XYChart
    );
    if (props.data) {
      // x.dateFormatter.inputDateFormat = "yyyy-MM-dd";
      x.data = props.data;





      //title
      var title = x.titles.create();
      title.text = props.title;
      title.fontSize = props.titleFontSize;
      title.marginTop = 0;
      title.marginBottom = 0;
      title.fontWeight = 600;
      title.fill =props.titleColor;

      // Create axes
      // var dateAxis = x.xAxes.push(new am4charts.DateAxis());
      var valueAxis = x.xAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.labels.template.fontSize =props.labelFontSize;
      valueAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      valueAxis.renderer.line.strokeOpacity = 0.2;
      valueAxis.renderer.line.strokeWidth = 1;
      valueAxis.renderer.line.stroke = am4core.color("#000");
      // valueAxis.title.text = "Actual";

      /* Create axes */

      var categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = props.category
        ? props.category
        : "time";
      categoryAxis.renderer.minGridDistance = 15;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.labels.template.fontSize = props.labelFontSize;
      categoryAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      categoryAxis.renderer.line.strokeOpacity = 0.2;
      categoryAxis.renderer.line.strokeWidth = 1;
      categoryAxis.renderer.line.stroke = am4core.color("#000");
      // categoryAxis.renderer.labels.template.adapter.add(
      //   "dy",
      //   function (dy, target) {
      //     if (target.dataItem && target.dataItem.index & (2 == 2)) {
      //       return dy + 25;
      //     }
      //     return dy;
      //   }
      // );


      // let valueLabel = x.series.bullets.push(new am4charts.LabelBullet());
      // valueLabel.label.text = "Hello";
      // valueLabel.label.fontSize = 10;




      /* Create series */
      let columnSeries = x.series.push(new am4charts.ColumnSeries());
      // columnSeries.name = "actual";
      columnSeries.xAxis = valueAxis;
      columnSeries.dataFields.valueX = props.colValue ? props.colValue : "actual";
      columnSeries.dataFields.categoryY = props.category
        ? props.category
        : "time";
      columnSeries.name = props.colValue ? props.colValue : "actual";
      // columnSeries.columns.template.width = am4core.percent(40);
      columnSeries.columns.template.clickable = true;
      columnSeries.columns.template.tooltipText =
        "{categoryY}: [bold]{valueX}[/]";
      columnSeries.columns.template.fillOpacity = 0.8;
      columnSeries.columns.template.strokeOpacity = 0;


           x.colors.list = [
        am4core.color(props.barColor[0]),
        am4core.color(props.barColor[1]),
        am4core.color(props.barColor[2]),
        am4core.color(props.barColor[3]),
        am4core.color(props.barColor[4]),
        am4core.color(props.barColor[5]),
        am4core.color(props.barColor[6]),
        am4core.color(props.barColor[7]),
        am4core.color(props.barColor[8]),
        am4core.color(props.barColor[9])

      ];


      columnSeries.columns.template.adapter.add("fill", (fill, target) => {
        return target.dataItem ? x.colors.getIndex(target.dataItem.index) : fill;
      });
      columnSeries.columns.template.column.cornerRadiusTopLeft = props.barCornerRadius[0];
      columnSeries.columns.template.column.cornerRadiusTopRight =  props.barCornerRadius[1];
      columnSeries.columns.template.column.cornerRadiusBottomLeft = props.barCornerRadius[2];
      columnSeries.columns.template.column.cornerRadiusBottomRight =  props.barCornerRadius[3];
      columnSeries.columns.template.events.on("hit", function (ev) {
        if (props.onChange) {
          props.onChange({
            _id: ev.target.dataItem.categories.categoryY,
            value: ev.target.dataItem.values.valueY.value
          });

        }
      }, this);

      var shadow = columnSeries.filters.push(new am4core.DropShadowFilter());
      shadow.dx = 20;
      shadow.dy = 20;
      shadow.blur = 5;
      chart.current = x;


      var valueLabel = columnSeries.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = "[bold]{valueX}[/]%";
      valueLabel.label.fontSize = 10;
      valueLabel.label.horizontalCenter = "right";
      valueLabel.label.dx = -10;
      // valueLabel.locationX = 1;





    }

    return () => {
      x.dispose();
    };
  });

  return (
    <div>
      {/* <div id={(props.divId) ? props.divId : "DivID"} style={{ width: "100%", height: "330px" }}></div> */}
      {props.data ? (
        <div
          id={props.divId ? props.divId : "DivID"}
          style={{
          
            width: props.chartDivWidth ,
            height: props.chartDivHeight ,
            padding: "0px",
            marginLeft: "10px",
            marginTop: "0px",
            // boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
            // borderRadius: "10px",
            // background: "rgb(106,106,111)",
            // backgroundImage:
            //   "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,1) 57%, rgba(33,32,40,1) 100%)",
            //   border: "2px solid #6a6a6f"

          }}
        ></div>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default BasicBarGraphHor;
